import { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Table,
  Spinner,
  Row,
  Col,
} from "react-bootstrap";

import {
  doc,
  getDoc,
} from "firebase/firestore";

import { db } from "./config";
import Header from "./Header";

import {
  decryptValue,
} from "./utils/crypto";

function Home() {
  const currentYear =
    new Date().getFullYear();

  const [year, setYear] =
    useState(currentYear);

  const [chartData, setChartData] =
    useState({});

  const [loading, setLoading] =
    useState(false);

  const [currentTime, setCurrentTime] = useState("");
  const [latestResult, setLatestResult] = useState(null);

  const months = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  const monthLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const updateDateTime = () => {
    const now = new Date();

    const date = now.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    const time = now.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    });

    setCurrentTime(`${date} ${time}`);
  };

  // const fetchTodayResult = async () => {
  //   try {
  //     const now = new Date();

  //     const currentYear = now.getFullYear().toString();

  //     const monthKeys = [
  //       "jan",
  //       "feb",
  //       "mar",
  //       "apr",
  //       "may",
  //       "jun",
  //       "jul",
  //       "aug",
  //       "sep",
  //       "oct",
  //       "nov",
  //       "dec",
  //     ];

  //     const currentMonth = monthKeys[now.getMonth()];
  //     const currentDay = now.getDate().toString();

  //     const snap = await getDoc(doc(db, "chart_data", currentYear));

  //     if (!snap.exists()) {
  //       setTodayNumber(null);
  //       return;
  //     }

  //     const data = snap.data();

  //     const value = data?.[currentMonth]?.[currentDay];

  //     if (!value) {
  //       setTodayNumber(null);
  //       return;
  //     }

  //     try {
  //       setTodayNumber(decryptValue(value));
  //     } catch {
  //       setTodayNumber(value);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const fetchTodayResult = async () => {
  //   try {
  //     const now = new Date();

  //     const currentYear = now.getFullYear().toString();

  //     const monthKeys = [
  //       "jan",
  //       "feb",
  //       "mar",
  //       "apr",
  //       "may",
  //       "jun",
  //       "jul",
  //       "aug",
  //       "sep",
  //       "oct",
  //       "nov",
  //       "dec",
  //     ];

  //     const currentMonth = monthKeys[now.getMonth()];
  //     const currentDay = now.getDate().toString();

  //     const snap = await getDoc(
  //       doc(db, "chart_data", currentYear)
  //     );

  //     if (!snap.exists()) {
  //       setTodayNumber(null);
  //       setResultTime(null);
  //       return;
  //     }

  //     const data = snap.data();

  //     const result =
  //       data?.[currentMonth]?.[currentDay];

  //     if (!result) {
  //       setTodayNumber(null);
  //       setResultTime(null);
  //       return;
  //     }

  //     let number = "";

  //     try {
  //       number = decryptValue(result.number);
  //     } catch {
  //       number = result.number;
  //     }

  //     setTodayNumber(number);

  //     setResultTime(
  //       result.time?.toDate
  //         ? result.time.toDate()
  //         : null
  //     );

  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const fetchTodayResult = async () => {
    try {

      const currentYear = new Date()
        .getFullYear()
        .toString();

      const snap = await getDoc(
        doc(db, "chart_data", currentYear)
      );

      if (!snap.exists()) {
        setLatestResult(null);
        return;
      }

      const data = snap.data();

let latest = null;

months.forEach((month, monthIndex) => {

  const monthData = data?.[month] || {};

  Object.entries(monthData).forEach(([day, item]) => {

    let number = "";

    try {
      number = decryptValue(item.number);
    } catch {
      number = item.number;
    }

    // Actual chart date
    const chartDate = new Date(
      Number(currentYear),
      monthIndex,
      Number(day)
    );

    if (
      !latest ||
      chartDate > latest.chartDate
    ) {
      latest = {
        number,
        month,
        day,
        chartDate,
        time: item.time?.toDate
          ? item.time.toDate()
          : null,
      };
    }

  });

});

setLatestResult(latest);

      setLatestResult(latest);

    } catch (err) {

      console.log(err);

    }
  };

  const fetchYearData = async () => {
    try {
      setLoading(true);

      const docRef = doc(
        db,
        "chart_data",
        year.toString()
      );

      const snapshot =
        await getDoc(docRef);

      if (!snapshot.exists()) {
        setChartData({});
        return;
      }

      const data =
        snapshot.data();

      const decryptedData =
        {};

      months.forEach(
        (month) => {
          decryptedData[
            month
          ] = {};

          const monthData =
            data?.[
            month
            ] || {};

          // Object.entries(
          //   monthData
          // ).forEach(
          //   ([
          //     day,
          //     value,
          //   ]) => {
          //     try {
          //       decryptedData[
          //         month
          //       ][day] =
          //         decryptValue(
          //           value
          //         );
          //     } catch {
          //       decryptedData[
          //         month
          //       ][day] =
          //         value;
          //     }
          //   }
          // );


          Object.entries(monthData).forEach(([day, item]) => {

            let number = "";

            try {
              number = decryptValue(item.number);
            } catch {
              number = item.number;
            }

            decryptedData[month][day] = {
              number,
              time: item.time?.toDate
                ? item.time.toDate()
                : null,
            };

          });

        }
      );

      setChartData(
        decryptedData
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchYearData();
  // }, [year]);

  useEffect(() => {
    fetchYearData();
  }, [year]);

  useEffect(() => {
    updateDateTime();

    const timer = setInterval(updateDateTime, 1000);

    fetchTodayResult();

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <Header />

      <Card className="shadow-lg">
        <Card.Body className="text-center py-4">

          <h3
            className="fw-bold mb-0 text-danger"
            style={{
              fontSize: "clamp(1.8rem,4vw,3rem)",
            }}
          >
            Punjab Night Satta King Chart {year}
          </h3>

        </Card.Body>
      </Card>

      <div className="px-5">
        <Card
          className="shadow-lg border-0 rounded-4 mb-4"
          style={{ margin: "25px auto" }}
        >
          <Card.Body className="text-center py-3">

            <h2
              className="fw-bold mb-1"
              style={{
                color: "#8e24aa",
              }}
            >
              {latestResult && (

                <div className="mb-3">

                  <div className="h3 fw-bold">

                    {latestResult.day}{" "}

                    {monthLabels[
                      months.indexOf(
                        latestResult.month
                      )
                    ]}

                    {" "}

                    {latestResult.time.getFullYear()}

                  </div>

                  {/* <small className="text-muted">

                    Updated :

                    {" "}

                    {latestResult.time.toLocaleString("en-IN")}

                  </small> */}

                </div>

              )}
            </h2>

            <h3
              className="fw-bold mb-3"
            >
              Punjab Night Satta King Live Result Today
            </h3>

            <div
              className="fw-bold mb-1 h1"
              style={{
                color: "#ff1493",
              }}
            >
              PUNJAB
            </div>

            {loading ? (
              <Spinner animation="border" />
            ) : latestResult ? (
              <h2
                style={{
                  color: "#008000",
                  fontSize: 80
                }}
                className="fw-bold"
              >
                {latestResult.number}
              </h2>
            ) : (
              <h2
                className="fw-bold text-danger"
                style={{
                  // fontSize: "clamp(1.6rem,5vw,3rem)"
                }}
              >
                No Number Chosen Yet
              </h2>
            )}

          </Card.Body>
        </Card>
      </div>


      <Container
        fluid="lg"
        className="py-4"
      >
        {/* Header Card */}

        <Card className="shadow-lg border-0 mb-4">
          <Card.Body>
            <Row className="align-items-center">

              <Col
                xs={12}
                md={8}
              >
                <h3>
                  Daily Number Chart
                </h3>

                <blockquote>
                  Select year to
                  view complete
                  chart history.
                </blockquote>
              </Col>

              <Col
                xs={12}
                md={4}
                className="mt-3 mt-md-0"
              >
                <Form.Label>
                  Select Year
                </Form.Label>

                <Form.Select
                  value={year}
                  onChange={(
                    e
                  ) =>
                    setYear(
                      e.target
                        .value
                    )
                  }
                >
                  {Array.from(
                    {
                      length: 15,
                    },
                    (_, i) =>
                      currentYear -
                      i
                  ).map(
                    (
                      year
                    ) => (
                      <option
                        key={
                          year
                        }
                        value={
                          year
                        }
                      >
                        {year}
                      </option>
                    )
                  )}
                </Form.Select>
              </Col>

            </Row>
          </Card.Body>
        </Card>

        {/* Chart Table */}

        <Card className="shadow-lg border-0">
          <Card.Body>

            {loading ? (
              <div className="text-center py-5">
                <Spinner
                  animation="border"
                  variant="dark"
                />
              </div>
            ) : (
              <div className="table-responsive">

                <Table
                  bordered
                  hover
                  className="align-middle text-center"
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          minWidth:
                            "80px",
                        }}
                        className="bg-danger"
                      >
                        {year}
                      </th>

                      {monthLabels.map(
                        (
                          month
                        ) => (
                          <th
                            className="bg-danger"
                            key={
                              month
                            }
                          >
                            {month}
                          </th>
                        )
                      )}
                    </tr>
                  </thead>

                  <tbody>

                    {Array.from(
                      {
                        length: 31,
                      },
                      (_, i) =>
                        i + 1
                    ).map(
                      (
                        day
                      ) => (
                        <tr
                          key={
                            day
                          }
                        >
                          <td className="fw-bold">
                            {
                              day
                            }
                          </td>

                          {months.map(
                            (
                              month
                            ) => (
                              <td
                                key={`${month}-${day}`}
                              >
                                {chartData?.[month]?.[day]?.number ? (
                                  <span className="fw-semibold">
                                    {chartData[month][day].number}
                                  </span>
                                ) : (
                                  <span className="text-muted">
                                    --
                                  </span>
                                )}
                              </td>
                            )
                          )}
                        </tr>
                      )
                    )}

                  </tbody>
                </Table>

              </div>
            )}

          </Card.Body>
        </Card>

      </Container>
    </>
  );
}

export default Home;